import React, { ReactNode, useState } from 'react';
import V4Context from './v4Context';

const V4ContextProvider = ({ children }: { children: ReactNode }) => {
  const [v4SupportedAsset, setV4SupportedAsset] = useState<any>(undefined);

  return (
    <V4Context.Provider
      value={{
        v4SupportedAsset,
        setV4SupportedAsset,
      }}
    >
      {children}
    </V4Context.Provider>
  );
};

export default V4ContextProvider;
